// Library Imports
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

// Local Imports
import endPoints from '@/redux/constant';
import axios from '@/redux/http';

const initialState = {
  loading: false,
  error: null,
  statistics: null,
  dashboardData: null,
  dashboardDataLoading: false,
  dashboardDataError: null,
};

export const getDashboardDataAPIFn = createAsyncThunk(
  'adminDashboard/getDashboardData',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(endPoints.dashboardDataURL);
      const result = data?.result;
      return result && typeof result === 'object' ? result : null;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message || error?.response?.data || 'Failed to load dashboard data'
      );
    }
  }
);

export const getPaymentABTestStatisticsAPIFn = createAsyncThunk(
  'adminDashboard/getPaymentABTestStatistics',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(endPoints.paymentABTestStatisticsURL);
      return data?.result ?? null;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message || error?.response?.data || 'Failed to load statistics'
      );
    }
  }
);

export const adminDashboardSlice = createSlice({
  name: 'adminDashboard',
  initialState,
  reducers: {
    clearAdminDashboardStatistics: state => {
      state.statistics = null;
      state.error = null;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(getPaymentABTestStatisticsAPIFn.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPaymentABTestStatisticsAPIFn.fulfilled, (state, action) => {
        state.loading = false;
        state.statistics = action.payload;
        state.error = null;
      })
      .addCase(getPaymentABTestStatisticsAPIFn.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to load statistics';
        state.statistics = null;
      })
      .addCase(getDashboardDataAPIFn.pending, state => {
        state.dashboardDataLoading = true;
        state.dashboardDataError = null;
      })
      .addCase(getDashboardDataAPIFn.fulfilled, (state, action) => {
        state.dashboardDataLoading = false;
        state.dashboardData = action.payload;
        state.dashboardDataError = null;
      })
      .addCase(getDashboardDataAPIFn.rejected, (state, action) => {
        state.dashboardDataLoading = false;
        state.dashboardData = null;
        state.dashboardDataError = action.payload || 'Failed to load dashboard data';
      });
  },
});

export const { clearAdminDashboardStatistics } = adminDashboardSlice.actions;
export default adminDashboardSlice.reducer;
